import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onChange", "valueIsNumericString"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { NumericFormat } from 'react-number-format';
import { TextField } from '../text-field';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var NumberFormatInput = /*#__PURE__*/forwardRef(function (props, ref) {
  var onChange = props.onChange,
      valueIsNumericString = props.valueIsNumericString,
      other = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(NumericFormat, _objectSpread(_objectSpread({}, other), {}, {
      customInput: TextField,
      getInputRef: ref,
      onValueChange: function onValueChange(values) {
        if (onChange && other.name) {
          var newValue = {
            target: {
              name: other.name,
              value: valueIsNumericString ? values.floatValue || values.value : values.formattedValue
            }
          };
          onChange(newValue);
        }
      }
    }))
  });
});
NumberFormatInput.displayName = 'NumberFormatInput';
export { NumberFormatInput };